// import { useState, useEffect } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { AiOutlineApartment, AiOutlineUnorderedList } from "react-icons/ai";
// import css from "./catalog.module.css";
// import { fetchProducts, fetchProductsAll } from "../../function/productsSlice";
// import withFirebaseCollection from "../HOK/withFirebaseCollection";
// import Filter from "./filter";
// import CatalogProductComponent from "../standartComponent/productComponent/catalogProductComponent";
// import SatalogProductComponentsSmall from "../standartComponent/productComponent/catalogProductComponentsSmall";
// import SmallProductCartTop from "../standartComponent/productComponent/SmallProductCartTop";
// import DiscountAndAction from "./discountAndAction";
// import ViewProductCatalog from "./viewProductCatalog";
// import ListButtonCount from "./listButtonCount";

// const Catalog = ({
//   setVisitedProducts,
//   visitedProducts,
//   productsAll,
//   setCartCounterC,
//   setLikeCounterC,
// }) => {
//   const dispatch = useDispatch();
//   const [currentPage, setCurrentPage] = useState(1);
//   const [changeVisible, setChangeVisible] = useState(() => {
//     return localStorage.getItem("catalogView") === "list";
//   });

//   const productsPerPage = 10;
//   const filters = useSelector((state) => state.filters);
//   const searchResults = useSelector((state) => state.products.searchResults);
//   const [products, setProducts] = useState([]);

//   useEffect(() => {
//     const fetchData = async () => {
//       if (searchResults.length > 0) {
//         setProducts(searchResults);
//       } else if (filters.length === 0) {
//         const result = await dispatch(fetchProductsAll()).unwrap();
//         setProducts(result);
//       } else {
//         const result = await dispatch(fetchProducts(filters)).unwrap();
//         setProducts(result);
//       }
//     };

//     fetchData();
//   }, [filters, searchResults, dispatch]);

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const toggleView = () => {
//     setChangeVisible((prev) => {
//       const newView = !prev;
//       localStorage.setItem("catalogView", newView ? "list" : "grid");
//       return newView;
//     });
//   };

//   const startIndex = (currentPage - 1) * productsPerPage;
//   const endIndex = startIndex + productsPerPage;
//   const currentProducts = products.slice(startIndex, endIndex);

//   const numberOfPages = Math.ceil(products.length / productsPerPage);
//   const maxDisplayedPages = 5;
//   const firstDisplayedPages = Math.max(
//     currentPage - Math.floor(maxDisplayedPages / 2),
//     1
//   );
//   const lastDisplayedPages = Math.min(
//     firstDisplayedPages + maxDisplayedPages - 1,
//     numberOfPages
//   );

//   const pageNumbers = [];
//   for (let i = firstDisplayedPages; i <= lastDisplayedPages; i++) {
//     pageNumbers.push(i);
//   }
//   console.log("currentProducts", currentProducts);

//   return (
//     <>
//       <Filter filters={filters} />

//       {/* Кнопки зміни формату перегляду */}
//       <div className={css.wrapCatalogChanges}>
//         <p className={css.nameFormatPere}>Змінити формат перегляду</p>
//         {changeVisible ? (
//           <AiOutlineApartment
//             className={css.catalogVisibleCss}
//             onClick={toggleView}
//           />
//         ) : (
//           <AiOutlineUnorderedList
//             className={css.catalogVisibleCss}
//             onClick={toggleView}
//           />
//         )}
//       </div>

//       {/* Відображення товарів залежно від обраного формату */}
//       {!changeVisible &&
//         currentProducts.map((el) => (
//           <CatalogProductComponent
//             visitedProducts={visitedProducts}
//             setVisitedProducts={setVisitedProducts}
//             el={el}
//             key={el.uid}
//             setCartCounterC={setCartCounterC}
//             setLikeCounterC={setLikeCounterC}
//           />
//         ))}

//       {changeVisible && currentProducts.length > 0 && (
//         <>
//           <SatalogProductComponentsSmall
//             visitedProducts={visitedProducts}
//             setVisitedProducts={setVisitedProducts}
//             el={currentProducts[0]}
//             key={currentProducts[0].uid}
//             setCartCounterC={setCartCounterC}
//             setLikeCounterC={setLikeCounterC}
//           />
//           <div className={css.wrapSmallProductTwoType}>
//             {currentProducts.slice(1).map((el) => (
//               <SmallProductCartTop
//                 el={el}
//                 key={el.uid}
//                 setCartCounterC={setCartCounterC}
//                 setLikeCounterC={setLikeCounterC}
//               />
//             ))}
//           </div>
//         </>
//       )}

//       {/* Пагінація */}
//       <ListButtonCount
//         pageNumbers={pageNumbers}
//         handlePageClick={handlePageClick}
//         currentPage={currentPage}
//       />

//       {/* Додаткові секції */}
//       <DiscountAndAction />
//       <ViewProductCatalog
//         products={productsAll}
//         setCartCounterC={setCartCounterC}
//         setLikeCounterC={setLikeCounterC}
//       />
//     </>
//   );
// };

// export default withFirebaseCollection("seo")(Catalog);
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { AiOutlineApartment, AiOutlineUnorderedList } from "react-icons/ai";
import css from "./catalog.module.css";
import { fetchProducts, fetchProductsAll } from "../../function/productsSlice";
import { db } from "../../firebase";
import { getDocs, collection } from "firebase/firestore";
import Filter from "./filter";
import CatalogProductComponent from "../standartComponent/productComponent/catalogProductComponent";
import SatalogProductComponentsSmall from "../standartComponent/productComponent/catalogProductComponentsSmall";
import SmallProductCartTop from "../standartComponent/productComponent/SmallProductCartTop";
import DiscountAndAction from "./discountAndAction";
import ViewProductCatalog from "./viewProductCatalog";
import ListButtonCount from "./listButtonCount";

export default function Catalog({
  setVisitedProducts,
  visitedProducts,
  productsAll,
  setCartCounterC,
  setLikeCounterC,
}) {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [changeVisible, setChangeVisible] = useState(() => {
    return localStorage.getItem("catalogView") === "list";
  });

  const productsPerPage = 10;
  const filters = useSelector((state) => state.filters);
  const searchResults = useSelector((state) => state.products.searchResults);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    // const fetchData = async () => {
    //   let baseProducts = [];

    //   if (searchResults.length > 0) {
    //     baseProducts = searchResults;
    //   } else if (filters.length === 0) {
    //     baseProducts = await dispatch(fetchProductsAll()).unwrap();
    //   } else {
    //     baseProducts = await dispatch(fetchProducts(filters)).unwrap();
    //   }

    //   // 1️⃣ Завантажуємо всі actions
    //   const snapshotActions = await getDocs(collection(db, "actions"));
    //   const actions = snapshotActions.docs.map((doc) => ({
    //     id: doc.id,
    //     ...doc.data(),
    //   }));

    //   const now = new Date();

    //   // 2️⃣ Завантажуємо ВСІ продукти
    //   const snapshotProducts = await getDocs(collection(db, "product"));
    //   const allProducts = snapshotProducts.docs.map((doc) => ({
    //     id: doc.id,
    //     ...doc.data(),
    //   }));

    //   // 3️⃣ Шукаємо, які товари підходять під action
    //   const actionProducts = allProducts.filter((product) => {
    //     return actions.some((action) => {
    //       const start = action.startDate ? new Date(action.startDate) : null;
    //       const end = new Date(action.endDate);

    //       const matchProduct = action.appliesTo.products?.includes(product.uid);

    //       const productSeries = Array.isArray(product.seria)
    //         ? product.seria
    //         : typeof product.seria === "string" && product.seria !== ""
    //         ? [product.seria]
    //         : [];

    //       const matchSeries = productSeries.some((ser) =>
    //         action.appliesTo.series?.includes(ser)
    //       );

    //       const productAuthors = Array.isArray(product.textAutor)
    //         ? product.textAutor.map((a) => a.split(" ")[0].trim())
    //         : typeof product.textAutor === "string" && product.textAutor !== ""
    //         ? [product.textAutor.split(" ")[0].trim()]
    //         : [];

    //       const actionAuthors = Array.isArray(action.appliesTo.authors)
    //         ? action.appliesTo.authors.map((a) => a.split(" ")[0].trim())
    //         : [];

    //       const matchAuthor = productAuthors.some((a) =>
    //         actionAuthors.includes(a)
    //       );

    //       return (
    //         (matchProduct || matchSeries || matchAuthor) &&
    //         (!start || now >= start) &&
    //         now <= end
    //       );
    //     });
    //   });

    //   const actionProductsWithDiscount = actionProducts.map((product) => {
    //     const matchedAction = actions.find((action) => {
    //       const start = action.startDate ? new Date(action.startDate) : null;
    //       const end = new Date(action.endDate);

    //       const matchProduct = action.appliesTo.products?.includes(product.uid);

    //       const productSeries = Array.isArray(product.seria)
    //         ? product.seria
    //         : typeof product.seria === "string" && product.seria !== ""
    //         ? [product.seria]
    //         : [];

    //       const matchSeries = productSeries.some((ser) =>
    //         action.appliesTo.series?.includes(ser)
    //       );

    //       const productAuthors = Array.isArray(product.textAutor)
    //         ? product.textAutor.map((a) => a.split(" ")[0].trim())
    //         : typeof product.textAutor === "string" && product.textAutor !== ""
    //         ? [product.textAutor.split(" ")[0].trim()]
    //         : [];

    //       const actionAuthors = Array.isArray(action.appliesTo.authors)
    //         ? action.appliesTo.authors.map((a) => a.split(" ")[0].trim())
    //         : [];

    //       const matchAuthor = productAuthors.some((a) =>
    //         actionAuthors.includes(a)
    //       );

    //       return (
    //         (matchProduct || matchSeries || matchAuthor) &&
    //         (!start || now >= start) &&
    //         now <= end
    //       );
    //     });

    //     if (matchedAction) {
    //       return {
    //         ...product,
    //         actionDiscountPercent: matchedAction.discountPercent,
    //       };
    //     }

    //     return product;
    //   });

    //   const saleProducts = await dispatch(
    //     fetchProducts([{ field: "sale", value: "true" }])
    //   ).unwrap();

    //   const combined = [
    //     ...baseProducts,
    //     ...actionProductsWithDiscount.filter(
    //       (ap) => !baseProducts.some((bp) => bp.uid === ap.uid)
    //     ),
    //     ...saleProducts.filter(
    //       (sp) =>
    //         !baseProducts.some((bp) => bp.uid === sp.uid) &&
    //         !actionProductsWithDiscount.some((ap) => ap.uid === sp.uid)
    //     ),
    //   ];

    //   setProducts(combined);
    // };
    const fetchData = async () => {
      let baseProducts = [];

      if (searchResults.length > 0) {
        baseProducts = searchResults;
      } else if (filters.length === 0) {
        baseProducts = await dispatch(fetchProductsAll()).unwrap();
      } else {
        baseProducts = await dispatch(fetchProducts(filters)).unwrap();
      }

      // 1️⃣ Завантажуємо всі actions
      const snapshotActions = await getDocs(collection(db, "actions"));
      const actions = snapshotActions.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      const now = new Date();

      // 2️⃣ Завантажуємо ВСІ продукти
      const snapshotProducts = await getDocs(collection(db, "product"));
      const allProducts = snapshotProducts.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      // 3️⃣ Шукаємо, які товари підходять під action
      const actionProducts = allProducts.filter((product) => {
        return actions.some((action) => {
          const start = action.startDate ? new Date(action.startDate) : null;
          const end = new Date(action.endDate);

          const matchProduct = action.appliesTo.products?.includes(product.uid);

          const productSeries = Array.isArray(product.seria)
            ? product.seria
            : typeof product.seria === "string" && product.seria !== ""
            ? [product.seria]
            : [];

          const matchSeries = productSeries.some((ser) =>
            action.appliesTo.series?.includes(ser)
          );

          const productAuthors = Array.isArray(product.textAutor)
            ? product.textAutor.map((a) => a.split(" ")[0].trim())
            : typeof product.textAutor === "string" && product.textAutor !== ""
            ? [product.textAutor.split(" ")[0].trim()]
            : [];

          const actionAuthors = Array.isArray(action.appliesTo.authors)
            ? action.appliesTo.authors.map((a) => a.split(" ")[0].trim())
            : [];

          const matchAuthor = productAuthors.some((a) =>
            actionAuthors.includes(a)
          );

          return (
            (matchProduct || matchSeries || matchAuthor) &&
            (!start || now >= start) &&
            now <= end
          );
        });
      });

      const actionProductsWithDiscount = actionProducts.map((product) => {
        const matchedAction = actions.find((action) => {
          const start = action.startDate ? new Date(action.startDate) : null;
          const end = new Date(action.endDate);

          const matchProduct = action.appliesTo.products?.includes(product.uid);

          const productSeries = Array.isArray(product.seria)
            ? product.seria
            : typeof product.seria === "string" && product.seria !== ""
            ? [product.seria]
            : [];

          const matchSeries = productSeries.some((ser) =>
            action.appliesTo.series?.includes(ser)
          );

          const productAuthors = Array.isArray(product.textAutor)
            ? product.textAutor.map((a) => a.split(" ")[0].trim())
            : typeof product.textAutor === "string" && product.textAutor !== ""
            ? [product.textAutor.split(" ")[0].trim()]
            : [];

          const actionAuthors = Array.isArray(action.appliesTo.authors)
            ? action.appliesTo.authors.map((a) => a.split(" ")[0].trim())
            : [];

          const matchAuthor = productAuthors.some((a) =>
            actionAuthors.includes(a)
          );

          return (
            (matchProduct || matchSeries || matchAuthor) &&
            (!start || now >= start) &&
            now <= end
          );
        });

        if (matchedAction) {
          return {
            ...product,
            actionDiscountPercent: matchedAction.discountPercent,
          };
        }

        return product;
      });

      const saleProducts = await dispatch(
        fetchProducts([{ field: "sale", value: "true" }])
      ).unwrap();

      // 🔍 Перевірка: чи є активний фільтр sale
      const hasSaleFilter = filters.some(
        (f) => f.field === "sale" && f.value === "true"
      );

      // 🔧 Якщо sale є — додаємо акції й товари зі знижкою
      let combined = [...baseProducts];

      if (hasSaleFilter) {
        combined = [
          ...combined,
          ...actionProductsWithDiscount.filter(
            (ap) => !combined.some((bp) => bp.uid === ap.uid)
          ),
          ...saleProducts.filter(
            (sp) =>
              !combined.some((bp) => bp.uid === sp.uid) &&
              !actionProductsWithDiscount.some((ap) => ap.uid === sp.uid)
          ),
        ];
      }

      // ✅ Сортуємо завжди (навіть якщо акції не додавались)
      combined.sort((a, b) => {
        const sortA =
          a.sorterNumber && !isNaN(a.sorterNumber)
            ? Number(a.sorterNumber)
            : Infinity;
        const sortB =
          b.sorterNumber && !isNaN(b.sorterNumber)
            ? Number(b.sorterNumber)
            : Infinity;
        return sortA - sortB;
      });

      setProducts(combined);
    };
    fetchData();
  }, [filters, searchResults, dispatch]);

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const toggleView = () => {
    setChangeVisible((prev) => {
      const newView = !prev;
      localStorage.setItem("catalogView", newView ? "list" : "grid");
      return newView;
    });
  };

  const startIndex = (currentPage - 1) * productsPerPage;
  const endIndex = startIndex + productsPerPage;
  const currentProducts = products.slice(startIndex, endIndex);

  const numberOfPages = Math.ceil(products.length / productsPerPage);
  const maxDisplayedPages = 5;
  const firstDisplayedPages = Math.max(
    currentPage - Math.floor(maxDisplayedPages / 2),
    1
  );
  const lastDisplayedPages = Math.min(
    firstDisplayedPages + maxDisplayedPages - 1,
    numberOfPages
  );

  const pageNumbers = [];
  for (let i = firstDisplayedPages; i <= lastDisplayedPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <>
      <Filter filters={filters} />

      <div className={css.wrapCatalogChanges}>
        <p className={css.nameFormatPere}>Змінити формат перегляду</p>
        {changeVisible ? (
          <AiOutlineApartment
            className={css.catalogVisibleCss}
            onClick={toggleView}
          />
        ) : (
          <AiOutlineUnorderedList
            className={css.catalogVisibleCss}
            onClick={toggleView}
          />
        )}
      </div>

      {!changeVisible &&
        currentProducts.map((el) => (
          <CatalogProductComponent
            visitedProducts={visitedProducts}
            setVisitedProducts={setVisitedProducts}
            el={el}
            key={el.id || el.uid}
            setCartCounterC={setCartCounterC}
            setLikeCounterC={setLikeCounterC}
          />
        ))}

      {changeVisible && currentProducts.length > 0 && (
        <>
          <SatalogProductComponentsSmall
            visitedProducts={visitedProducts}
            setVisitedProducts={setVisitedProducts}
            el={currentProducts[0]}
            key={currentProducts[0].id || currentProducts[0].uid}
            setCartCounterC={setCartCounterC}
            setLikeCounterC={setLikeCounterC}
          />
          <div className={css.wrapSmallProductTwoType}>
            {currentProducts.slice(1).map((el) => (
              <SmallProductCartTop
                el={el}
                key={el.id || el.uid}
                setCartCounterC={setCartCounterC}
                setLikeCounterC={setLikeCounterC}
              />
            ))}
          </div>
        </>
      )}

      <ListButtonCount
        pageNumbers={pageNumbers}
        handlePageClick={handlePageClick}
        currentPage={currentPage}
      />

      <DiscountAndAction />
      <ViewProductCatalog
        products={productsAll}
        setCartCounterC={setCartCounterC}
        setLikeCounterC={setLikeCounterC}
      />
    </>
  );
}
